import { localStorageManager } from "@/services/localStorage";
import { LOCAL_STORAGE_BASE_KEYS } from "@/types/v2";

/**
 * Typography for the container title, keyed off the "small container headers"
 * toggle in the dashboard header. Both variants carry the same 2% tracking;
 * only size and weight change.
 */
export const CONTAINER_HEADER_TEXT_CLASSES = {
  default: "text-sm font-semibold tracking-[0.02em]",
  compact: "text-[11px] font-medium tracking-[0.02em]",
} as const;

export const getContainerHeaderTextClasses = (compact: boolean): string =>
  compact
    ? CONTAINER_HEADER_TEXT_CLASSES.compact
    : CONTAINER_HEADER_TEXT_CLASSES.default;

export const getInitialCompactContainerHeaders = (): boolean =>
  localStorageManager.getItem(
    LOCAL_STORAGE_BASE_KEYS.COMPACT_CONTAINER_HEADERS
  ) === "true";

export const persistCompactContainerHeaders = (compact: boolean): void => {
  localStorageManager.setItem(
    LOCAL_STORAGE_BASE_KEYS.COMPACT_CONTAINER_HEADERS,
    `${compact}`
  );
};
